import React, { useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { AppError } from '../../../../../errors/AppError';

import api from '../../../../../services/api';
import history from '../../../../../services/history';

import TitleBar from '../../../../../components/TitleBar';
import { FormWrapper, Form } from '../../../../../components/Form';
import Input from '../../../../../components/Form/Input';
import Select from '../../../../../components/Form/Input/Select';
import TextArea from '../../../../../components/Form/Input/TextArea';

import { opTokenDuracao, opTokenTipo } from '../../../../../lib/inputOption';

/** validação dos campos */
const schema = Yup.object().shape({
  nome: Yup.string().required('O campo "Nome" deve ser preenchido'),
  duracao: Yup.string().required('O campo "Duração" deve ser preenchido'),
  observacao: Yup.string()
    .max(500, 'O campo "Observação" precisa ter no máximo 500 caracteres')
    .required('O campo "Observação" deve ser preenchido'),
});

function EmpresaCatalogoTokenCriar() {
  const formRef = useRef(null);

  const location = useLocation();
  const { idEmpresa, idCatalogo, background } = location.state;

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        const { nome, duracao, observacao, tipo } = data;

        await api.post(
          `empresa/${idEmpresa}/catalogo/${idCatalogo}/token-acesso`,
          {
            nome,
            duracao,
            observacao,
            tipo,
          }
        );

        toast.success('Token gerado com sucesso!');

        history.goBack();
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [idEmpresa, idCatalogo]
  );

  return (
    <>
      <TitleBar back={!background} title="Criar token de acesso" />
      <FormWrapper>
        <Form
          id="formEmpresaCatalogoToken"
          ref={formRef}
          schema={schema}
          onSubmit={handleConfirmar}
          autoComplete="off"
        >
          <Form.Column>
            <Form.Row>
              <Input id="nome" name="nome" label="Nome" width={500} />
            </Form.Row>
            <Form.Row>
              <Select
                id="tipo"
                name="tipo"
                label="Tipo"
                isSearchable={false}
                options={opTokenTipo}
                defaultValue={opTokenTipo[0]}
                width={200}
              />
              <Select
                id="duracao"
                name="duracao"
                label="Duração (Dias)"
                isSearchable={false}
                options={opTokenDuracao}
                defaultValue={opTokenDuracao[0]}
                width={200}
              />
            </Form.Row>
            <Form.Row>
              <TextArea
                id="observacao"
                name="observacao"
                label="Observação"
                rows={5}
              />
            </Form.Row>
          </Form.Column>
          <Form.Separate withFlex />
          <Form.Footer>
            <button
              id="btn-cancel"
              type="button"
              onClick={() => history.goBack()}
            >
              Cancelar
            </button>
            <button id="btn-submit" type="submit">
              Confirmar
            </button>
          </Form.Footer>
        </Form>
      </FormWrapper>
    </>
  );
}

export { EmpresaCatalogoTokenCriar };
